import React from 'react';
import { BUTTON_TYPES } from '../../../base/ui/constants.web';
import { END_FOR_ALL_HINT, END_FOR_ALL_LABEL, LEAVE_CALL_HINT, LEAVE_CALL_LABEL } from '../../../interpreter-queue/groupEndForAll';
import { HangupContextMenuItem } from './HangupContextMenuItem';
/**
 * A group call host's two ways out, in the hang-up menu: leave (the call
 * goes on while 2 or more people are left in it) or end the call for
 * everyone. Each is a full-width button whose spoken label says what happens
 * to the others.
 *
 * @param {IProps} props - Component props.
 * @returns {JSX.Element}
 */
export default function GroupHangupChoices({ endNotifyMode, leaveNotifyMode, onEndForAll, onLeave }) {
    return (React.createElement(React.Fragment, null,
        React.createElement(HangupContextMenuItem, { accessibilityLabel: LEAVE_CALL_HINT, buttonKey: 'hangup', buttonType: BUTTON_TYPES.SECONDARY, label: LEAVE_CALL_LABEL, notifyMode: leaveNotifyMode, onClick: onLeave }),
        React.createElement(HangupContextMenuItem, { accessibilityLabel: END_FOR_ALL_HINT, buttonKey: 'end-meeting', buttonType: BUTTON_TYPES.DESTRUCTIVE, label: END_FOR_ALL_LABEL, notifyMode: endNotifyMode, onClick: onEndForAll })));
}
